import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";

type ConfettiBurstProps = {
  theme: "ageless" | "repeatmd";
};

const PARTICLE_COUNT = 40;

export const ConfettiBurst = ({ theme }: ConfettiBurstProps) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), 2500);
    return () => clearTimeout(t);
  }, []);

  const PARTICLES = useMemo(
    () =>
      Array.from({ length: PARTICLE_COUNT }, (_, i) => ({
        id: i,
        color: COLORS[theme][i % COLORS[theme].length],
        width: Math.random() * 10 + 3,
        height: Math.random() * 10 + 3,
        x: (Math.random() - 0.5) * 500,
        y: (Math.random() - 0.5) * 500,
        rotate: Math.random() * 720,
      })),
    [theme],
  );

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="pointer-events-none fixed inset-0 z-50 flex items-center justify-center"
          exit={{ opacity: 0 }}
          initial={{ opacity: 1 }}
        >
          {PARTICLES.map((p) => (
            <motion.div
              animate={{
                x: p.x,
                y: p.y,
                scale: [0, 1.5, 0],
                rotate: p.rotate,
              }}
              className="absolute rounded-full"
              initial={{ x: 0, y: 0, scale: 0 }}
              key={p.id}
              style={{
                backgroundColor: p.color,
                width: p.width,
                height: p.height,
              }}
              transition={{ duration: 2.5, ease: "easeOut" }}
            />
          ))}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

const COLORS = {
  ageless: [
    "hsl(var(--ageless-amber))",
    "hsl(var(--ageless-amber))",
    "hsl(var(--ageless-smoked-stone))",
    "hsl(var(--ageless-silt))",
    "hsl(var(--ageless-champagne-white))",
  ],
  repeatmd: [
    "hsl(var(--repeatmd-peach))",
    "hsl(var(--repeatmd-peach-tint))",
    "hsl(var(--repeatmd-peach-tint-2))",
    "hsl(var(--repeatmd-green))",
    "hsl(var(--repeatmd-gray))",
  ],
};
